import { memo } from 'react';
import PropTypes from 'prop-types';
import date from 'helpers/utils/date';

export function PersianDateFunc({ value, format }) {
  if (value) {
    const _date = date(value);

    if (_date.isValid()) {
      return _date.format(format);
    }
  }

  return '';
}

PersianDateFunc.propTypes = {
  format: PropTypes.string,
  time: PropTypes.bool,
  value: PropTypes.string
};

PersianDateFunc.defaultProps = {
  format: 'jYYYY/jMM/jDD - HH:mm',
  time: false,
  value: ''
};

export default memo(PersianDateFunc);
